export default {
    COMUM: {
        EFETUAR_LOGOUT: 'efetuarLogout',
        SET_MENU_AVATAR: 'setMenuAvatar',
        SET_TIMEZONE: 'setTimeZone',
        SET_PRODUTO: 'setProduto',
        SET_USUARIO_LOGADO: 'setUsuarioLogado',
        SET_USUARIO_LOGADO_UPDATE: 'setUsuarioLogadoUpdate',
        SET_CURRENT_PAGE: 'setCurrentPage',
        SET_ROTA_ORIGEM: 'setRotaOrigem',
        SET_HABILITAR_SALVAMENTO_AUTOMATICO: 'setHabilitarSalvamentoAutomatico',
        SET_DESABILITAR_SALVAMENTO_AUTOMATICO: 'setDesabilitarSalvamentoAutomatico',
        SET_LINK_ARQUIVO: 'setLinkArquivo',
        SET_NOTIFICACAO: 'setNotificacao',
        DISABLE_GLOBAL_LOADING: 'disableGlobalLoading',
        ENABLE_GLOBAL_LOADING: 'enableGlobalLoading',
        SET_GLOBAL_LOADING: 'setGlobalLoading',
        SET_LOADING_MESSAGE: 'setLoadingMessage',
        SET_NOTIFICATION: 'setNotification',
        SET_REDIRECT_URL: 'setRedirectUrl',
    },
    DRAWER: {
        SET_ASIDE: 'setAside',
        SET_ASIDE_HIDE: 'setAsideHide',
        TOOGLE_ASIDE: 'toogleAside',
    },
    USUARIO: {
        SET_AUTOCOMPLETE_NOMES_DOS_USUARIOS: 'setAutocompleteNomesDosUsuarios',
        SET_FILTROS_BUSCA_TODOS_USUARIOS: 'setFiltrosBuscaTodosUsuarios',
        SET_PAGINACAO_BUSCA_TODOS_USUARIOS: 'setPaginacaoBuscaTodosUsuarios',
        SET_RESUMO_DO_USUARIO: 'setResumoDoUsuario',
        RESETA_PAGE: 'resetaPage',
    },
    PERFIL: {
        SET_FILTROS_BUSCA_TODOS_PERFIS: 'setFiltrosBuscaTodosPerfis',
        SET_PAGINACAO_BUSCA_TODOS_PERFIS: 'setPaginacaoBuscaTodosPerfis',
        RESETA_PAGE: 'resetaPage',
    },
    COBRANCA: {
        SET_FILTROS_BUSCA_TODAS_COBRANCAS: 'setFiltrosBuscaTodasCobrancas',
        SET_PAGINACAO_BUSCA_TODAS_COBRANCAS: 'setPaginacaoBuscaTodasCobrancas',
        RESETA_PAGE: 'resetaPage',
        SET_ROTA_ORIGEM: 'setRotaOrigem',
        SET_FILTROS_BUSCA_TODAS_COBRANCAS_INTERNO: 'setFiltrosBuscaTodasCobrancasInterno',
        SET_PAGINACAO_BUSCA_TODAS_COBRANCAS_INTERNO: 'setPaginacaoBuscaTodasCobrancasInterno',
        RESETA_PAGE_INTERNO: 'resetaPageInterno',
        SET_FILTROS_BUSCA_TODAS_COBRANCAS_ATENDIMENTO: 'setFiltrosBuscaTodasCobrancasAtendimento',
        SET_PAGINACAO_BUSCA_TODAS_COBRANCAS_ATENDIMENTO: 'setPaginacaoBuscaTodasCobrancasAtendimento',
        RESETA_PAGE_ATENDIMENTO: 'resetaPageAtendimento',
    },
    ORCAMENTO: {
        SET_FILTROS_BUSCA_TODOS_ORCAMENTOS: 'setFiltrosBuscaTodosOrcamentos',
        SET_PAGINACAO_BUSCA_TODOS_ORCAMENTOS: 'setPaginacaoBuscaTodosOrcamentos',
        RESETA_PAGE: 'resetaPage'
    },
    SERVICO: {
        SET_FILTROS_BUSCA_TODOS_SERVICOS: 'setFiltrosBuscaTodosServicos',
        SET_PAGINACAO_BUSCA_TODOS_SERVICOS: 'setPaginacaoBuscaTodosServicos',
        RESETA_PAGE: 'resetaPage'
    },
    SERVICO_ATENDIMENTO: {
        SET_FILTROS_BUSCA_TODOS_SERVICOS_ATENDIMENTO: 'setFiltrosBuscaTodosServicosAtendimento',
        SET_PAGINACAO_BUSCA_TODOS_SERVICOS_ATENDIMENTO: 'setPaginacaoBuscaTodosServicosAtendimento',
        RESETA_PAGE_SERVICO_ATENDIMENTO: 'resetaPageServicoAtendimento',
    },
    SERVICO_ORCAMENTO: {
        SET_FILTROS_BUSCA_TODOS_SERVICOS_ORCAMENTO: 'setFiltrosBuscaTodosServicosOrcamento',
        SET_PAGINACAO_BUSCA_TODOS_SERVICOS_ORCAMENTO: 'setPaginacaoBuscaTodosServicosOrcamento',
        RESETA_PAGE_SERVICO_ORCAMENTO: 'resetaPageServicoOrcamento',
    },
    CADASTROS: {
        PACIENTE: {
            SET_DADOS_GERAIS: 'setDadosGerais',
            SET_FILTROS_BUSCA_TODOS_PACIENTES: 'setFiltrosBuscaTodosPacientes',
            SET_PAGINACAO_BUSCA_TODOS_PACIENTES: 'setPaginacaoBuscaTodosPacientes',
            RESETA_PAGE: 'resetaPage',
            SET_ROTA_ORIGEM: 'setRotaOrigem',
        },
        CIDADE: {
            SET_DADOS_GERAIS: 'setDadosGerais',
            SET_FILTROS_BUSCA_TODAS_CIDADES: 'setFiltrosBuscaTodasCidades',
            SET_PAGINACAO_BUSCA_TODAS_CIDADES: 'setPaginacaoBuscaTodasCidades',
            RESETA_PAGE: 'resetaPage',
        },
    },
    ATENDIMENTO: {
        SET_FILTROS_BUSCA_TODOS_ATENDIMENTOS: 'setFiltrosBuscaTodosAtendimentos',
        SET_PAGINACAO_BUSCA_TODOS_ATENDIMENTOS: 'setPaginacaoBuscaTodosAtendimentos',
        RESETA_PAGE: 'resetaPage',
        PROCEDIMENTO: {
            SET_FILTROS_BUSCA_TODOS_PROCEDIMENTOS: 'setFiltrosBuscaTodosProcedimentos',
            SET_PAGINACAO_BUSCA_TODOS_PROCEDIMENTOS: 'setPaginacaoBuscaTodosProcedimentos',
            RESETA_PAGE: 'resetaPage',
        }
    },
    ODONTOGRAMA: {
        ATUALIZAR_ODONTOGRAMA: 'atualizarOdontograma'
    },
    PARAMETROS: {
        SET_PARAMETROS: 'setParametros',
    },
    GALERIA_PACIENTE: {
        SET_FILTROS_BUSCA_TODAS_MIDIAS: 'setFiltrosBuscaTodasMidias',
        SET_PAGINACAO_BUSCA_TODAS_MIDIAS: 'setPaginacaoBuscaTodasMidias',
        RESETA_PAGE: 'resetaPage',
    },
}
